import { TemplateRef } from '@angular/core';

export class TooltipConfig {
  content: string|TemplateRef<any>;
  position: 'top' | 'bottom';
  positionX: 'start' | 'center' | 'end';
  size: 'xs' | 'md' | 'lg';
}
